import React from 'react';
import { SearchIcon } from '../../svgs';
import './SearchBarWithActions.css';
import { useTranslation } from 'react-i18next';

/**
 * @param {{
 *   value: string,
 *   onChange: (value: string) => void,
 *   children?: React.ReactNode,
 *   style?: React.CSSProperties,
 *   searchicon?: React.ReactNode,
 *   className?: string,
 * }} props
 * @param {React.Ref<HTMLDivElement>} ref
 */
const SearchBarWithActions = ({ value, onChange, children, style, searchicon = null, className = '' }, ref) => {
  const [t] = useTranslation('shared');
  return (
    <div className={`searchBarWithActions ${className}`.trim()} style={style} ref={ref}>
      <div className='searchBarContainer'>
        {searchicon ? searchicon :  <SearchIcon size={18} /> }
        <input
          name='search'
          placeholder={t('searchBar.placeholder', 'Sök')}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
      {children}
    </div>
  );
}
export default React.memo(React.forwardRef(SearchBarWithActions))
